import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../language.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor(public readonly language: LanguageService) { }

  ngOnInit(): void {
  }

}
